import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowLeft, Trash2, Store, Phone, MapPin, User } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function EditUserProfilePage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('session_token');
    axios.get(`${BACKEND_URL}/api/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setUser(res.data))
      .catch(() => toast.error('Erro ao carregar perfil'))
      .finally(() => setLoading(false));
  }, []);

  const handleDeleteAccount = async () => {
    if (!confirm('Tem certeza que deseja excluir sua conta? Esta acao e irreversivel.')) return;
    if (!confirm('ULTIMA CONFIRMACAO: Excluir conta permanentemente?')) return;
    try {
      const token = localStorage.getItem('session_token');
      await axios.delete(`${BACKEND_URL}/api/auth/account`, { headers: { Authorization: `Bearer ${token}` } });
      localStorage.removeItem('session_token');
      toast.success('Conta excluida com sucesso');
      navigate('/');
    } catch (error) {
      toast.error('Erro ao excluir conta');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-slate-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Button variant="ghost" onClick={() => navigate('/dashboard')} className="mb-6" data-testid="back-btn">
          <ArrowLeft className="h-4 w-4 mr-2" /> Voltar
        </Button>

        <Card className="hero-card mb-6">
          <CardHeader><CardTitle className="text-2xl" data-testid="profile-title">Meu Perfil</CardTitle></CardHeader>
          <CardContent className="space-y-5">
            <div className="flex items-center gap-4 pb-4 border-b border-white/20">
              {user?.picture ? (
                <img src={user.picture} alt={user.name} className="w-16 h-16 rounded-full object-cover border-2 border-white/30" />
              ) : (
                <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center border-2 border-white/30">
                  <User className="h-8 w-8 text-white/70" />
                </div>
              )}
              <div>
                <p className="text-lg font-bold text-white" data-testid="profile-name">{user?.name}</p>
                <p className="text-sm text-slate-300" data-testid="profile-email">{user?.email}</p>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-slate-300 shrink-0" />
                <div>
                  <p className="text-xs text-slate-400">WhatsApp</p>
                  <p className="text-white font-medium" data-testid="profile-whatsapp">{user?.whatsapp || 'Nao informado'}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <MapPin className="h-5 w-5 text-slate-300 shrink-0" />
                <div>
                  <p className="text-xs text-slate-400">Cidade</p>
                  <p className="text-white font-medium" data-testid="profile-city">{user?.city ? `${user.city}, ${user.state || ''}` : 'Nao informado'}</p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-white border-2 border-green-200 mb-6">
          <CardContent className="py-6">
            <Button onClick={() => navigate('/setup')}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 text-lg rounded-lg"
              data-testid="become-merchant-btn">
              <Store className="h-5 w-5 mr-2" /> Quero ser Lojista
            </Button>
            <p className="text-xs text-slate-500 text-center mt-2">Crie cupons e alcance mais clientes</p>
          </CardContent>
        </Card>

        <Card className="bg-white border-2 border-red-200">
          <CardHeader>
            <CardTitle className="text-lg text-red-600 flex items-center gap-2"><Trash2 className="h-5 w-5" /> Zona de Perigo</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-slate-600 mb-4">Ao excluir sua conta, todos os seus dados, cupons ativos e pontos serao removidos permanentemente.</p>
            <Button variant="outline" onClick={handleDeleteAccount}
              className="border-red-300 text-red-600 hover:bg-red-50 hover:text-red-700"
              data-testid="delete-account-btn">
              <Trash2 className="h-4 w-4 mr-2" /> Excluir Minha Conta
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
